import { Toast as _Toast } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { Z_INDEX } from "~/styles/z-index";

export const Toast = styled(_Toast)`
  margin: 12px;
  z-index: ${Z_INDEX.TOAST};
`;
